export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            this.plugin.call(GG);
            GG.log('Popup plugin loaded.');
        }
        else {
            GG.log('Popup plugin needs jQuery.');
        }
    },
    plugin: function () {
        var $ = this.$;
        var app = this;
        var scrollTop = 0;
        var scrollTopElement = '';
        $('html').data('width', $('html').width());
        if (app.isMobile) {
            $('body').addClass('is_mobile');
        }
        var closePopup = function (popup) {
            (app.historyRestoreUrl || $.noop)();
            app.togglePopup($(popup).attr('id'));
        };
        $('body').on('click', '.popup .popup-close, .popup .popup__close', function (e) {
            closePopup($(this).closest('.popup')[0]);
            e.preventDefault();
        });
        $(document).on('click', '.popup.hideover', function () {
            closePopup(this);
        });
        $(document).on('click', '.hideover .popup-container', function (e) {
            e.stopPropagation();
        });
        $(document).keyup(function (e) {
            if (e.keyCode === 27) {
                closePopup($('.popup:visible').last()[0]);
            }
        });
        var touchStartEvent;
        var blockScrollSelector = $('.popup-overlay').length ? '.popup-overlay' : '.popup';
        $('body')
            .on('touchstart', blockScrollSelector, function (e) {
            touchStartEvent = e.originalEvent || e;
        })
            .on('touchmove', blockScrollSelector, function (e) {
            var ev = e.originalEvent || e;
            if (touchStartEvent) {
                if ((ev.pageY > touchStartEvent.pageY && this.scrollTop === 0) ||
                    (ev.pageY < touchStartEvent.pageY && this.scrollTop + this.offsetHeight >= this.scrollHeight))
                    e.preventDefault();
            }
        });
        $(window).resize(function () {
            $('html').data('width', $('html').width());
            if ($('.popup:visible').length) {
                $('body').css('height', $(window).height());
            }
        });
        app.togglePopup = function (id) {
            if (typeof id === 'undefined') {
                $('.popup.opened').each(function () {
                    app.togglePopup($(this).attr('id'));
                });
                return;
            }
            var $popup = $('#' + id);
            if (!$popup.length)
                return;
            var $html = $('html');
            var $body = $('body');
            if ($popup.is('.opened')) {
                $html.removeClass('popup-is-opened');
                if (scrollTopElement === 'html') {
                    $html[0].scrollTop = scrollTop;
                }
                else {
                    $body[0].scrollTop = scrollTop;
                }
                var togglePopupSettings = app.config.togglepopupsettings;
                if (togglePopupSettings && togglePopupSettings.elements.length > 0) {
                    for (var i = 0, k = togglePopupSettings.elements.length; i < k; i++) {
                        if (typeof togglePopupSettings.attr === 'undefined') {
                            $(togglePopupSettings.elements[i]).css('padding-right', '');
                        }
                        else {
                            if (typeof togglePopupSettings.attr === 'string') {
                                $(togglePopupSettings.elements[i]).css(togglePopupSettings.attr, '');
                            }
                            else if (typeof togglePopupSettings.attr === 'object' &&
                                togglePopupSettings.attr.length === togglePopupSettings.elements.length) {
                                $(togglePopupSettings.elements[i]).css(togglePopupSettings.attr[i], '');
                            }
                            else {
                                $(togglePopupSettings.elements[i]).css('padding-right', '');
                            }
                        }
                    }
                }
                else {
                    $('.wrapper').css('padding-right', '');
                }
                $popup.removeClass('opened');
                $('.topbar').css('z-index', '');
                (app.callback || $.noop)('popupClosed', $popup);
            }
            else {
                scrollTopElement = $body[0].scrollTop ? 'body' : 'html';
                scrollTop = $html[0].scrollTop || $body[0].scrollTop;
                $html.addClass('popup-is-opened');
                var togglePopupSettings = app.config.togglepopupsettings;
                if (togglePopupSettings && togglePopupSettings.elements.length > 0) {
                    for (var i = 0, k = togglePopupSettings.elements.length; i < k; i++) {
                        if (typeof togglePopupSettings.attr === 'undefined') {
                            $(togglePopupSettings.elements[i]).css('padding-right', $html.width() - $html.data('width'));
                        }
                        else {
                            if (typeof togglePopupSettings.attr === 'string') {
                                $(togglePopupSettings.elements[i]).css(togglePopupSettings.attr, $html.width() - $html.data('width'));
                            }
                            else if (typeof togglePopupSettings.attr === 'object' &&
                                togglePopupSettings.attr.length === togglePopupSettings.elements.length) {
                                $(togglePopupSettings.elements[i]).css(togglePopupSettings.attr[i], $html.width() - $html.data('width'));
                            }
                            else {
                                $(togglePopupSettings.elements[i]).css('padding-right', $html.width() - $html.data('width'));
                            }
                        }
                    }
                }
                else {
                    $('.wrapper').css('padding-right', $html.width() - $html.data('width'));
                }
                $popup.addClass('opened');
                $('.topbar').css('z-index', 1000);
                (app.callback || $.noop)('popupOpened', $popup);
            }
        };
    }
};
